module.exports = __webpack_public_path__ + "static/media/44_tn.0c850538.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/44_tn.jpg
// module id = 532
// module chunks = 0